module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('category.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.category),
      expression: "filters.category"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('brand.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.brand),
      expression: "filters.brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand,
      domProps: {
        "value": brand
      }
    }, [_vm._v(_vm._s(brand))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('ageGroup.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.ageGroup),
      expression: "filters.ageGroup"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "ageGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.ageGroups), function(ageGroup) {
    return _c('option', {
      key: ageGroup,
      domProps: {
        "value": ageGroup
      }
    }, [_vm._v(_vm._s(_vm.$t((ageGroup + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('gender.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.gender),
      expression: "filters.gender"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.genders), function(gender) {
    return _c('option', {
      key: gender,
      domProps: {
        "value": gender
      }
    }, [_vm._v(_vm._s(_vm.$t(("gender." + gender + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Faixa de preço",
      "columns": 6
    }
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('slider', {
    attrs: {
      "range": true,
      "format": _vm.formatRangePrice,
      "min": _vm.priceRange.less,
      "max": _vm.priceRange.highest
    },
    on: {
      "change": _vm.changeRange
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47c3e298","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/feedUpdatePrice/filters/ecommerce/Moovin.vue
// module id = 3118
// module chunks = 0